// Test is still running
export const IN_PROGRESS = 'IN_PROGRESS';
// No changes
export const PASSED = 'PASSED';
// A change was detected, but hasn't been accepted or rejected
export const PENDING = 'PENDING';
// A change was detected, and was accepted
export const ACCEPTED = 'ACCEPTED';
// A change was detected, and was rejected
export const DENIED = 'DENIED';
export const BROKEN = 'BROKEN';
export const FAILED = 'FAILED';

export const TestStatus = {
  IN_PROGRESS,
  PASSED,
  PENDING,
  ACCEPTED,
  DENIED,
  BROKEN,
  FAILED,
} as const;

export type TestStatus = (typeof TestStatus)[keyof typeof TestStatus];

export const isBaselineStatuses: TestStatus[] = [PASSED, ACCEPTED];

export const isBaseline = ({ status }: { status?: TestStatus }) =>
  isBaselineStatuses.includes(status);

export const isCopyable = ({ status }: { status?: TestStatus }) =>
  [PASSED, PENDING, ACCEPTED].includes(status);

export const isError = ({ status }: { status?: TestStatus }) => [FAILED, BROKEN].includes(status);

export const isReviewable = ({ status }: { status?: TestStatus }) =>
  [PENDING, ACCEPTED, DENIED].includes(status);

export const hasCapture = ({ status }: { status?: TestStatus }) =>
  [PASSED, PENDING, ACCEPTED, DENIED].includes(status);
